"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Selecteer tijd',
  rangePlaceholder: ['Start tijd', 'Eind tijd']
};
var _default = locale;
exports["default"] = _default;